
import { PrintProcessor } from "./PrintProcessor";
import { PosInitData } from 'tplus-poslogin';
import PrintApi from "../../../api/PrintApi";
import '../../../commom/Challenger';
const _print = Symbol('print');
import {Message} from 'tplus-components-touch';

/**
 * 项目储值单打印
 */
export class ProjectStoragePrintProcessBlock
{
    static async execute(dtoID, dto) {
        if (!dto) {
            dto={};
            dto.Idstore = PosInitData('storeID');
            dto.POSCode = PosInitData('posCode');
        }
        let printEntity = await PrintApi.GetPrintInfomation(dto);

        // 打印
        await this[_print](dtoID, printEntity);
    }

    static async [_print](dtoID, printEntity) {
        $T.debugger();

        if (printEntity
            && printEntity.PrintDetailEntitys
            && printEntity.PrintDetailEntitys.length > 0
        ) {
            const printDetailEntity = printEntity.PrintDetailEntitys[0];
            // 会员储值单模板
            printDetailEntity.printTemplateID=printEntity.ProjectStoragePrintTemplate;
            // 会员储值单
            printDetailEntity.bizCode='ME27';
            // 单据名称
            printDetailEntity.voucherName='ProjectStorageVoucher';
            // 打印次数
            printDetailEntity.printCount=printDetailEntity.storagePrintNum;
            delete printDetailEntity.ExtendProperty;
            // 是否启用打印机
            // printDetailEntity.IsEnablePrinter=true;

            // 单据打印的场合
            await PrintProcessor.execute(dtoID, printDetailEntity);
        }
    }
}

global.ProjectStoragePrintProcessBlock=ProjectStoragePrintProcessBlock;